import { OnboardingStep } from '../../OnboardingStep/OnboardingStep'
import { getStepStatus } from '../utils'

interface DownloadAppStepProps {
  readonly completed: boolean
  readonly enabled: boolean
}

export function DownloadAppStep({
  completed,
  enabled
}: Readonly<DownloadAppStepProps>) {
  const handleDownloadApp = () => {
    // Pending logic implementation
  }

  return (
    <OnboardingStep
      title="Download the CookUnity App"
      description="Order, track deliveries, and manage your subscription easily, all from your phone."
      status={getStepStatus(completed, enabled)}
      icon="download"
      action={{
        label: 'Get the App',
        onClick: handleDownloadApp
      }}
    />
  )
}
